// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalEligibilityPatientResult {
    static getAttributeTypeMap() {
        return MedicalEligibilityPatientResult.attributeTypeMap;
    }
}
MedicalEligibilityPatientResult.discriminator = undefined;
MedicalEligibilityPatientResult.additionalProperties = false;
MedicalEligibilityPatientResult.attributeTypeMap = [
    {
        "name": "changeFlag",
        "baseName": "changeFlag",
        "type": "boolean"
    },
    {
        "name": "address",
        "baseName": "address",
        "type": "MedicalEligibilityAddress"
    },
    {
        "name": "birthDate",
        "baseName": "birthDate",
        "type": "Date"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "gender",
        "baseName": "gender",
        "type": "MedicalEligibilityGender"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "middleName",
        "baseName": "middleName",
        "type": "string"
    },
];
//# sourceMappingURL=medicalEligibilityPatientResult.js.map